import { Injectable } from '@angular/core';
import {
  ConfigActionTypes,
  FetchAppConfigSuccess,
  FetchAppInfoSuccess
} from '@app/core/actions/config';
import { AppConfigService } from '@app/core/services/app-config.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { exhaustMap, switchMap } from 'rxjs/operators';

@Injectable()
export class ConfigEffects {

  fetchAppConfig$ = createEffect(() => this.actions$.pipe(
    ofType(ConfigActionTypes.FetchAppConfig),
    exhaustMap(() =>
      this.appConfigService
        .fetchConfig()
        .pipe(
          switchMap(config => of(new FetchAppConfigSuccess(config)))
        )
    )
  ));

  fetchAppInfo$ = createEffect(() => this.actions$.pipe(
    ofType(ConfigActionTypes.FetchAppInfo),
    exhaustMap(() =>
      this.appConfigService
        .fetchAppInfo()
        .pipe(
          switchMap(info => of(new FetchAppInfoSuccess(info)))
        )
    )
  ));

  constructor(
    private actions$: Actions,
    private appConfigService: AppConfigService
  ) {
  }
}
